import './password-input.css';
import eyeOpened from '../../imgs/eye-opened.png';
import eyeClosed from '../../imgs/eye-closed.png';
import whiteEyeOpened from '../../imgs/white-eye-opened.png';
import whiteEyeClosed from '../../imgs/white-eye-closed.png';
import { useState, useEffect } from 'react';
import { useUI } from '../../UIContext';
import { Theme } from '../../constants/theme';

function PasswordInput({ id, className, value, disabled, onChange, onValidate, warningMsg, shouldValidate, maxLength }) {
    const [passType, setPassItem] = useState('password');
    const [invalidValue, setInvalidValue] = useState(false);
    const { effectiveTheme } = useUI();

    const isDarkTheme = effectiveTheme === Theme.DARK;
    const passIcon = passType === 'password'
        ? (isDarkTheme ? whiteEyeOpened : eyeOpened)
        : (isDarkTheme ? whiteEyeClosed : eyeClosed);

    useEffect(() => {
        if (shouldValidate)
            setInvalidValue(!onValidate());
    }, [shouldValidate, onValidate]);

    function handlePassIcon() {
        if (disabled)
            return;

        if (passType === 'password')
            setPassItem('text');
        else
            setPassItem('password');
    }

    return (
        <div className='password-container'>
            <div className="password-input">
                <input
                    id={id}
                    className={className}
                    type={passType}
                    placeholder="Palavra-passe"
                    value={value}
                    disabled={disabled}
                    onChange={(e) => {
                        setInvalidValue(false);
                        onChange(e);
                    }}
                    onBlur={() => setInvalidValue(!onValidate())}
                    maxLength={maxLength}
                />
                <img src={passIcon} alt='password-toggle-visibility' onClick={handlePassIcon} />
            </div>

            <span className={`password-warning-msg ${invalidValue ? 'show' : ''}`}>
                {warningMsg}
            </span>
        </div>
    );
}

export default PasswordInput;